
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as auth7mkrNdHS1yOEqKXCBLOxFS1_pVXBuAG56CPJ2QwZ_6sMeta } from "/opt/buildhome/repo/pages/auth.vue?macro=true";
import { default as testuIHN47Vh_C1tmOl545DicizmXB_oJj4COR6x_qStdScMeta } from "/opt/buildhome/repo/pages/test.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as sitemapRAisXoZK5HnX9gP4GeOCNyiX2jhMw_43c23RS0_z7RoMeta } from "/opt/buildhome/repo/pages/sitemap.vue?macro=true";
import { default as supportl3tCf2l8KOksVuBZ_45lwf_OWoI3RlNHbxGYLJvIGfIa4Meta } from "/opt/buildhome/repo/pages/support.vue?macro=true";
import { default as welcome4Ldt1FmcVB21DwoxSZOYiMzi6S0HjXSuOu4_5Bc_45klQMeta } from "/opt/buildhome/repo/pages/welcome.vue?macro=true";
import { default as theloginaX61JyD2AOoW8N6xCBrcFkk_45vyzvQy7SZfi9PUbXUbkMeta } from "/opt/buildhome/repo/pages/thelogin.vue?macro=true";
import { default as _91_46_46_46slug_93HP6U6e9bwgf0ykoIufCZbuAYgN6P35DF5liqOl8GvSAMeta } from "/opt/buildhome/repo/pages/changelog/[...slug].vue?macro=true";
import { default as changelog_hFhWWc4COhVeKip6sv2KNzgOMTdEsqFvShOe8ksc2wMeta } from "/opt/buildhome/repo/pages/changelog.vue?macro=true";
import { default as _91slug_932Fp8k_45vWHUvFEin6h4uMkfxKhKlDJSOr0MNROvBQTtkMeta } from "/opt/buildhome/repo/pages/game/[slug].vue?macro=true";
import { default as indexSQcm2MO475NMYQ6bS_uQGUWvGqSXnm805T4ueTdDMm4Meta } from "/opt/buildhome/repo/pages/genres/index.vue?macro=true";
import { default as indexPwAew5v4WhtAJx3h7CzVj7o_45jJXZ7p5HkA9_45Ki8uJFUMeta } from "/opt/buildhome/repo/pages/import/index.vue?macro=true";
import { default as indexsSHEynImpmVJQBsgEWtpFbTIimvAlNbjHy0W37sieOIMeta } from "/opt/buildhome/repo/pages/account/index.vue?macro=true";
import { default as indexTAzdxzswbLhCqTG21Zk3QlFD7dWogWsnalYG6CMHUTkMeta } from "/opt/buildhome/repo/pages/journal/index.vue?macro=true";
import { default as updateEJ2V6MBhJ_45ZvXxXwCosPTs1Y7FtPkcmfv0lATTmtdCUMeta } from "/opt/buildhome/repo/pages/account/update.vue?macro=true";
import { default as _91_46_46_46slug_93yzHiQlKkvRcLWbiAfnAb5WHEpZZzlU82tG0DTIZLvBAMeta } from "/opt/buildhome/repo/pages/docs/[...slug].vue?macro=true";
import { default as indexirtGdDOU_45t4Hw2cDzbItebj9Ophv94MhY0DxdfBtHjcMeta } from "/opt/buildhome/repo/pages/community/index.vue?macro=true";
import { default as lists09fkSZeNFPvwM2wqVMiMC5_jnIjbxsPwP1Qopi_45Y59YMeta } from "/opt/buildhome/repo/pages/community/lists.vue?macro=true";
import { default as _91_46_46_46slug_93zL3V8AzSO7Vug5MVZs5OT9HmiPRw_45w2UIAx7MW1gtJEMeta } from "/opt/buildhome/repo/pages/games/[...slug].vue?macro=true";
import { default as _91section_93dj_45k1X0Oz_RBg18Yyd_64Ujnyt3xHcRkkU02dUL_45FS0Meta } from "/opt/buildhome/repo/pages/account/[section].vue?macro=true";
import { default as _91platform_93H7lHMb_45wG5m2QKZSpjEoVeMAybJ0MvF7OaX_45XLyH58IMeta } from "/opt/buildhome/repo/pages/import/[platform].vue?macro=true";
import { default as _91_46_46_46slug_934qLqF91H2Bg_igwbetYh5DdI9w7DejK7ZNfPNTFbk_cMeta } from "/opt/buildhome/repo/pages/library/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93TugX5FH5fHX_45gY3EPX_453_45anOkli5LnSZvEd7nuS1pRkMeta } from "/opt/buildhome/repo/pages/my/list/[...slug].vue?macro=true";
import { default as _91slug_93NGekPzZOHvj3xXTQfZioc_45vH5XXV7_zzIOq5QzWHyRUMeta } from "/opt/buildhome/repo/pages/@[user]/list/[slug].vue?macro=true";
import { default as meftPg0CHAbuVlxPlnkMbO2_4TI2Lz5gs0t4EZIkwzEfYMeta } from "/opt/buildhome/repo/pages/account/sections/me.vue?macro=true";
import { default as logsAwW1bPjCavOldUa1n5ie0u9geWIqj9FEnPkq4vZOCe8Meta } from "/opt/buildhome/repo/pages/account/sections/logs.vue?macro=true";
import { default as listsIDhu1ry3XvnqO8AIT_45QSgAs1_Cvxe6JrcmT7UCCm0YQMeta } from "/opt/buildhome/repo/pages/account/sections/lists.vue?macro=true";
import { default as states36b9T0cIv3L_kDAjKosscMxnOe3pwXux1_459hjmf_45PmMMeta } from "/opt/buildhome/repo/pages/account/sections/states.vue?macro=true";
import { default as backupsmqq0_45xWDZnxLNUuXUmBsPUhKkaADGQLml8LoEw5xZqUMeta } from "/opt/buildhome/repo/pages/account/sections/backups.vue?macro=true";
import { default as databasevOwMyFBGqkvTMcR7TJg__nNeedLT54kayj1_QTbAjsEMeta } from "/opt/buildhome/repo/pages/account/sections/database.vue?macro=true";
import { default as communitylgW6mxHcfrHKyH8GjBiGwXsuZpxU8pvi_msuRy7WHcwMeta } from "/opt/buildhome/repo/pages/account/sections/community.vue?macro=true";
import { default as preferencesBksQE6_45687D_Lfl6RPmRtYHtF03ie8ZHB7MNRff6l7YMeta } from "/opt/buildhome/repo/pages/account/sections/preferences.vue?macro=true";
import { default as integrationsTPIsi3eYmG8SUy8AFQFic_457ehHKBV_454LlXjnSl2f0u4Meta } from "/opt/buildhome/repo/pages/account/sections/integrations.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/opt/buildhome/repo/pages/auth.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/opt/buildhome/repo/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/opt/buildhome/repo/pages/sitemap.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/opt/buildhome/repo/pages/support.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcome4Ldt1FmcVB21DwoxSZOYiMzi6S0HjXSuOu4_5Bc_45klQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/welcome.vue")
  },
  {
    name: "thelogin",
    path: "/thelogin",
    component: () => import("/opt/buildhome/repo/pages/thelogin.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    component: () => import("/opt/buildhome/repo/pages/changelog.vue"),
    children: [
  {
    name: "changelog-slug",
    path: ":slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/changelog/[...slug].vue")
  }
]
  },
  {
    name: "game-slug",
    path: "/game/:slug()",
    component: () => import("/opt/buildhome/repo/pages/game/[slug].vue")
  },
  {
    name: "genres",
    path: "/genres",
    component: () => import("/opt/buildhome/repo/pages/genres/index.vue")
  },
  {
    name: "import",
    path: "/import",
    component: () => import("/opt/buildhome/repo/pages/import/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexsSHEynImpmVJQBsgEWtpFbTIimvAlNbjHy0W37sieOIMeta || {},
    redirect: "/account/me",
    component: () => import("/opt/buildhome/repo/pages/account/index.vue")
  },
  {
    name: "journal",
    path: "/journal",
    component: () => import("/opt/buildhome/repo/pages/journal/index.vue")
  },
  {
    name: "account-update",
    path: "/account/update",
    meta: updateEJ2V6MBhJ_45ZvXxXwCosPTs1Y7FtPkcmfv0lATTmtdCUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/update.vue")
  },
  {
    name: "docs-slug",
    path: "/docs/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/docs/[...slug].vue")
  },
  {
    name: "community",
    path: "/community",
    component: () => import("/opt/buildhome/repo/pages/community/index.vue")
  },
  {
    name: "community-lists",
    path: "/community/lists",
    component: () => import("/opt/buildhome/repo/pages/community/lists.vue")
  },
  {
    name: "games-slug",
    path: "/games/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/games/[...slug].vue")
  },
  {
    name: "account-section",
    path: "/account/:section()",
    component: () => import("/opt/buildhome/repo/pages/account/[section].vue")
  },
  {
    name: "import-platform",
    path: "/import/:platform()",
    component: () => import("/opt/buildhome/repo/pages/import/[platform].vue")
  },
  {
    name: "library-slug",
    path: "/library/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/library/[...slug].vue")
  },
  {
    name: "my-list-slug",
    path: "/my/list/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/my/list/[...slug].vue")
  },
  {
    name: "@user-list-slug",
    path: "/@:user()/list/:slug()",
    component: () => import("/opt/buildhome/repo/pages/@[user]/list/[slug].vue")
  },
  {
    name: "account-sections-me",
    path: "/account/sections/me",
    component: () => import("/opt/buildhome/repo/pages/account/sections/me.vue")
  },
  {
    name: "account-sections-logs",
    path: "/account/sections/logs",
    component: () => import("/opt/buildhome/repo/pages/account/sections/logs.vue")
  },
  {
    name: "account-sections-lists",
    path: "/account/sections/lists",
    component: () => import("/opt/buildhome/repo/pages/account/sections/lists.vue")
  },
  {
    name: "account-sections-states",
    path: "/account/sections/states",
    component: () => import("/opt/buildhome/repo/pages/account/sections/states.vue")
  },
  {
    name: "account-sections-backups",
    path: "/account/sections/backups",
    component: () => import("/opt/buildhome/repo/pages/account/sections/backups.vue")
  },
  {
    name: "account-sections-database",
    path: "/account/sections/database",
    component: () => import("/opt/buildhome/repo/pages/account/sections/database.vue")
  },
  {
    name: "account-sections-community",
    path: "/account/sections/community",
    component: () => import("/opt/buildhome/repo/pages/account/sections/community.vue")
  },
  {
    name: "account-sections-preferences",
    path: "/account/sections/preferences",
    component: () => import("/opt/buildhome/repo/pages/account/sections/preferences.vue")
  },
  {
    name: "account-sections-integrations",
    path: "/account/sections/integrations",
    component: () => import("/opt/buildhome/repo/pages/account/sections/integrations.vue")
  }
]